const TODAY = "Hoy";
const YESTERDAY = "Ayer";
const THIS_WEEK = "Esta Semana";
const LAST_WEEK = "Semana Pasada";
const THIS_MONTH = "Este Mes";
const LAST_MONTH = "Mes Pasado";
const THIS_YEAR = "Este Año";
const CUSTOM = "Personalizado";
const TOMORROW = "Mañana";

const NUM_TODAY = 0;
const NUM_YESTERDAY = 1;
const NUM_THIS_WEEK = 2;
const NUM_LAST_WEEK = 3;
const NUM_THIS_MONTH = 4;
const NUM_LAST_MONTH = 5;
const NUM_THIS_YEAR = 6;
const NUM_CUSTOM = 7;
const NUM_TOMORROW = 8;

const get = {
  [NUM_TODAY]: TODAY,
  [NUM_YESTERDAY]: YESTERDAY,
  [NUM_THIS_WEEK]: THIS_WEEK,
  [NUM_LAST_WEEK]: LAST_WEEK,
  [NUM_THIS_MONTH]: THIS_MONTH,
  [NUM_LAST_MONTH]: LAST_MONTH,
  [NUM_THIS_YEAR]: THIS_YEAR,
  [NUM_CUSTOM]: CUSTOM,
  [NUM_TOMORROW]: TOMORROW
};

export default {
  get,
  TODAY,
  YESTERDAY,
  THIS_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  LAST_MONTH,
  THIS_YEAR,
  CUSTOM,
  TOMORROW,
  NUM_TODAY,
  NUM_YESTERDAY,
  NUM_THIS_WEEK,
  NUM_LAST_WEEK,
  NUM_THIS_MONTH,
  NUM_LAST_MONTH,
  NUM_THIS_YEAR,
  NUM_CUSTOM,
  NUM_TOMORROW
};
